import { Route, Routes } from 'react-router-dom';

import CouponPage from './coupon';
import CouponsMain from './main';

export default function CouponsPage() {
  return (
    <Routes>
      <Route element={<CouponsMain />} path="" />
      <Route element={<CouponPage />} path=":coupon_id/*" />
    </Routes>
  );
}
